import { useContext, useState, useRef } from 'react';

import Form from 'react-bootstrap/Form';

import './custom.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { GlobalContext } from "../../contexts/globalContext";
import { ProjectDetailsContext } from '../../contexts/projectDetailsContext';

import styles from './PD_HeaderComponent.module.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons'

import New_InputTextComponent from '../../components/keyboard/New_InputTextComponent';


const HeaderDetailsComponent = ({ seeNotification, setSeeNotification }) => {
    const {
        setSelectedParentForFiles, currentUser, selectedProject, setAlertMessage, setSelectedProject, socketRef, statusProjectList,
        setProjectsList, setTopicFiles, selectedTopicIdRef, keyboardRef
    } = useContext(GlobalContext);

    const { setExtended } = useContext(ProjectDetailsContext);

    const editNameRef = useRef()

    const [clickEditName, setClickEditName] = useState()
    const [isChecked, setIsChecked] = useState(selectedProject.active);

    const handleSwitchChange = (e) => {
        setIsChecked(e.target.checked);

        if (!e.target.checked) {
            setAlertMessage({ type: "INFO", message: "The project is now inactive. All content is hidden from users." });
        } else {
            setAlertMessage({ type: "INFO", message: "The project is now active. All content is visible to users." });
        }

        socketRef.current.emit("UPDATE_PROJECT", { projectId: selectedProject._id, newData: { active: e.target.checked } },
            (project) => {
                if (currentUser?.function?.code === "ADMN" || currentUser?.role.toLowerCase() === "administrator") {
                    let updatedActive = { active: project.active }
                    setSelectedProject(selectedProject => ({
                        ...selectedProject,
                        ...updatedActive
                    }))
                }
            }
        );
    };

    function handleCloseProject() {
        setSelectedProject()
        setSeeNotification()
        selectedTopicIdRef.current = null
        setExtended(null)
        setTopicFiles()
        setSelectedParentForFiles();

        socketRef.current.emit('GET_ALL_PROJECTS', currentUser._id, null, statusProjectList, (projects) => {
            setProjectsList(projects)
        });
    }

    function handleEditName() {
        editNameRef.current.blur();
        if (editNameRef.current?.value !== selectedProject.name) {
            socketRef.current.emit("UPDATE_PROJECT", { projectId: selectedProject._id, newData: { name: editNameRef.current?.value ? editNameRef.current?.value : "Default Title" } },
                (project) => {
                    let updatedName = { name: project.name ? project.name : selectedProject.name }
                    setSelectedProject(selectedProject => ({
                        ...selectedProject,
                        ...updatedName
                    }))
                }
            );
        }
        setClickEditName(false)

    }

    return (
        <div style={{ flexDirection: "row", display: "flex" }}>
            <div style={{ display: 'flex', flexDirection: 'row' }} onClick={handleCloseProject}>
                <FontAwesomeIcon className={styles.goBack} icon={byPrefixAndName.fal["arrow-left"]} />
                <div className={styles.goBackText} >Back to Projects</div>
            </div>
            <div className={styles.notifications} >
                <FontAwesomeIcon icon={byPrefixAndName.fal['calendar-days']} onClick={() => setSeeNotification(!seeNotification)} />
            </div>
            <div className={styles.switchDiv} style={{ color: isChecked ? "#33FFC8" : "#FFFFFF80" }}>
                <div style={{ color: isChecked ? "#FFFFFF80" : "#33FFC8" }}>Inactive</div>
                <Form>
                    <Form.Check
                        type="switch"
                        id="custom-switch"
                        label="Active"
                        className='custom-switch'
                        checked={isChecked}
                        onChange={handleSwitchChange}
                    />
                </Form>
            </div>


            {!clickEditName && <div className={styles.editName} style={{ width: 2800, justifyContent: 'center' }}>
                <div className={styles.titleCenterText} style={{ position: 'relative' }} onClick={() => setClickEditName(true)}>{selectedProject.name}</div>
                {(currentUser?.function?.code === "ADMN" || currentUser?.role.toLowerCase() === "administrator") &&
                    <FontAwesomeIcon className={styles.editIconClicked} style={{ top: 7 }} icon={byPrefixAndName.fal['pen']} onClick={() => setClickEditName(true)} />}
            </div>}

            {clickEditName && <div className={styles.editName}>
                <New_InputTextComponent fontSize={60} width="1426px" onBlur={() => handleEditName()} ref={editNameRef} focused={true} styleType='EDT' keyboardRef={keyboardRef}
                    value={selectedProject.name} />
            </div>}

        </div>

    );

}

export default HeaderDetailsComponent;